import {
  browserDefaultTimezone,
  FormType,
  getDefaultChargeDay,
  isWeekdayChargeDay,
  StripeRecurringInterval,
  SubscriptionChargeDay,
} from "@simplyk/common";

import { FormV2ContextType } from "@/canvas/features/FormV2/contexts/FormV2Context";
import {
  getDonationFrequencyFromStripeInterval,
  getSubscriptionIntervalFromStripeInterval,
} from "@/common/helpers/donationRecurrence";
import { getDonationAmountSource } from "@/common/helpers/suggestedAmountsTracking";

export const getDonationSelectionTracking = (context: FormV2ContextType) =>
  context.type === FormType.DonationForm
    ? {
        recurrenceInterval: getDonationFrequencyFromStripeInterval(context.form.getValues("recurrenceInterval")),
        amountSource: getDonationAmountSource(context),
        chargeDayCustomized: isChargeDayCustomized(
          context.form.getValues("recurrenceInterval"),
          context.form.getValues("chargeDay")
        ),
      }
    : null;

const isChargeDayCustomized = (
  stripeRecurrenceInterval: StripeRecurringInterval | null | undefined,
  chargeDay: SubscriptionChargeDay | null | undefined
): boolean | undefined => {
  const recurrenceInterval = getSubscriptionIntervalFromStripeInterval(stripeRecurrenceInterval);
  if (!chargeDay || !recurrenceInterval) {
    return undefined;
  }
  const defaultChargeDay = getDefaultChargeDay({ recurrenceInterval, timezone: browserDefaultTimezone });
  if (isWeekdayChargeDay(chargeDay) && isWeekdayChargeDay(defaultChargeDay)) {
    return chargeDay.weekday !== defaultChargeDay.weekday;
  }
  if (!isWeekdayChargeDay(chargeDay) && !isWeekdayChargeDay(defaultChargeDay)) {
    return chargeDay.dayOfMonth !== defaultChargeDay.dayOfMonth;
  }
  return true;
};
